__turbopack_context__.v({
  "center": "gSgIWG_center",
  "root": "gSgIWG_root",
});
